import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-[#0A3B36] px-6 text-center text-white">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center"
      >
        <img src="/favicon.png" alt="Playbook Distro" className="mb-6 h-14 w-14 rounded-2xl ring-1 ring-white/20" />
        <p className="font-display text-7xl font-extrabold tracking-tight text-[#6E97A2]">404</p>
        <h1 className="mt-3 font-display text-2xl font-bold">This page isn't on the setlist</h1>
        <p className="mt-2 max-w-md text-sm text-white/60">
          The link may be broken or the report was moved. Let's get you back to your artists.
        </p>
        <Link
          data-testid="notfound-home-link"
          to="/"
          className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#0A3B36] transition-transform hover:-translate-y-0.5"
        >
          <Compass className="h-4 w-4" /> Back to Artists
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
        <p className="mt-8 text-xs uppercase tracking-widest text-white/30">Playbook Distro</p>
      </motion.div>
    </div>
  );
}
